import { createVuetify } from 'vuetify'
import { ko } from 'vuetify/locale'
export default defineNuxtPlugin(app => {
  app.vueApp.use(createVuetify({ ssr: false, locale: { locale: 'ko', messages: { ko } },
    theme: { defaultTheme: 'techedu', themes: { techedu: { dark: false, colors: {
      primary: '#1e40af', secondary: '#1e293b', background: '#f8fafc', surface: '#ffffff', 'on-surface': '#0f172a', error: '#b42336', success: '#26765b',
    } } } },
    defaults: { VBtn: { color: 'primary', variant: 'flat', rounded: 'lg' }, VCard: { elevation: 0, rounded: 'lg' },
      VTextField: { variant: 'outlined', density: 'comfortable', hideDetails: 'auto' } },
  }))
})
